import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Tabs,
  Tab,
  Card,
  CardActions,
  Button
} from '@material-ui/core';
import { Link, useParams, useHistory } from 'react-router-dom';
import { TabPanel, TabContext } from '@material-ui/lab';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';
import { Breadcrumb, BackdropCircular } from 'components';
import { getMetadataAPI } from 'api';
import MyLibrary from 'pages/library';
import Promos from './Promos';
import PromoCalendar from './PromoCalendar';
import RequestedPromotions from './RequestedPromotions.tsx';


const useStyles = makeStyles(() => ({
  customBorder: {
    borderBottom: '1px solid rgba(189, 189, 189, 0.5)',
  }
}));


export default function MyPromotions() {
  const history = useHistory();
  const { tabName = 'active' } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();

  const {profile} = useSelector((state) => state.user);
  const permissions = profile?.config?.permissions || {};
  const {libraryLoading} = useSelector((state) => state.library);
  const loading = libraryLoading;

  useEffect(() => {
    getMetadataAPI({dispatch});
  }, []);

  const handleTabChange = (e, value) => {
    history.push({
      pathname: `/my-promotions/${value}`,
    });
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Automatic Promotions'}
          ]}
        />
      </div>
      <CardActions className="mx-10 justify-end">
        {permissions?.promotionsLibrary &&
          <Link to="/promotions-library/browse-promotion" underline="none">
            <Button
              className="uppercase custom-check-all custom-check-all-select mr-2"
              variant="contained"
              color="primary"
              underline="none"
            >
              Search from Library
            </Button>
          </Link>}
        {(permissions?.promotionsRequestCustom || permissions?.promotionsRequestSimple) &&
          <Link to="/customized-promotion">
            <Button variant="outlined" className="uppercase">
              Request Custom Promotion
            </Button>
          </Link>}
      </CardActions>
      <div className="mb-sm-30" >
        <Card className="mx-10">
          <TabContext value={tabName}>
            <Tabs
              value={tabName}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              className={clsx('mx-10', classes.customBorder)}
            >
              <Tab className="capitalize font-medium" value={'library'} label="My Library" />
              <Tab className="capitalize font-medium" value={'active'} label="Active" />
              <Tab className="capitalize font-medium" value={'scheduled'} label="Scheduled" />
              <Tab className="capitalize font-medium" value={'complete'} label="Complete" />
              <Tab className="capitalize font-medium" value={'calendar'} label="Calendar" />
              <Tab className="capitalize font-medium" value={'requested_promotions'} label="Requested Promotions" />
            </Tabs>
            <TabPanel value={'library'}>
              <MyLibrary tabName={tabName} />
            </TabPanel>
            <TabPanel value={'active'}>
              <Promos promoStatus="Started" tabName={tabName} />
            </TabPanel>
            <TabPanel value={'scheduled'}>
              <Promos promoStatus="Published" tabName={tabName} />
            </TabPanel>
            <TabPanel value={'complete'}>
              <Promos promoStatus="Finished" tabName={tabName} />
            </TabPanel>
            <TabPanel value={'calendar'}>
              <PromoCalendar />
            </TabPanel>
            <TabPanel value={'requested_promotions'} className="p-0">
              <RequestedPromotions />
            </TabPanel>
          </TabContext>
        </Card>
      </div>
      <BackdropCircular loading={loading} />
    </div>
  );
}
